import React from "react";
const Dashboard = React.lazy(() => import("../container/Dashboard/Dashboard"));
const EfoneClients = React.lazy(() => import("../container/eFolderClients/EfoneClients"));
const ClientUpdate = React.lazy(() => import("../container/ClientUpdate/ClientUpdate"));
const V5Client = React.lazy(() => import("../container/V5/Clients/Details/ClientUpdate"));
const AddUser = React.lazy(() => import("../container/AddUser/AddUser"));
const Addons = React.lazy(() => import("../container/Addons/Addons"));
const Logout = React.lazy(() => import("../components/Logout-component/Logout"));
const AddNewUser = React.lazy(() => import("../container/AddNew/AddNewUser"));
const Reports = React.lazy(() => import("../container/Reports/Reports"));
const Security = React.lazy(() => import("../container/Security/Security"));
const VendorReports = React.lazy(() => import("../container/Reports/vendorReports/VendorReports"));
const UsageReports = React.lazy(() => import("../container/Reports/usageReports/UsageReports"));
const PhoneNumbers = React.lazy(() => import("../container/PhoneNumbers/PhoneNumbers"));
const PhoneNumbersNew = React.lazy(() => import("../container/PhoneNumbersNew/PhoneNumbersNew"));
const V5PhoneNumbers = React.lazy(() => import("../container/V5/PhoneNumbers/PhoneNumbers"));
const AssignNumberEdit_v5 = React.lazy(() => import("../container/V5/PhoneNumbers/PhoneNumberTable/AssignNumberEdit"));
const V5PhoneNumbersList = React.lazy(() => import("../container/V5/PhoneNumbers/PurchaseNumber"));
const BuyPhoneNumber_v5 = React.lazy(() => import("../container/V5/PhoneNumbers/BuyPhoneNumber"));
const Agents = React.lazy(() => import("../container/AdminUsers/Agents/Agents"));
const Departments = React.lazy(() => import("../container/AdminUsers/Departments/Departments"));
const Outbound = React.lazy(() => import("../container/Providers/Outbound/index"));

const createPrefixAlertsBlockSettings = React.lazy(() => import("../container/Providers/Outbound/createPrefixAlertsBlockSettings"));
const listPrefixAlertsBlockSettings = React.lazy(() => import("../container/Providers/Outbound/listPrefixAlertsBlockSettings"));
const listProviderMasterPrefix = React.lazy(() => import("../container/Providers/Outbound/listProviderMasterPrefixes"));

const QueueDetails = React.lazy(() => import("../container/Providers/RatesQueue/Details"));
const E911provider = React.lazy(() => import('../container/Providers/E99Provider/E99Provider'));
const Inbound = React.lazy(() => import("../container/Providers/Inbound/Inbound"));
const Sms = React.lazy(() => import("../container/Providers/Sms/Sms"));
const Tickets = React.lazy(() => import("../container/Tickets/Tickets"));
const EfoneSupport = React.lazy(() => import("../container/EfoneSupport/EfoneSupport"));
const AddDepartment = React.lazy(() => import("../container/AddDepartment/AddDepartment"));
const AddPortalUser = React.lazy(() => import("../container/AddPortaluser/AddPortalUser"));
const AddPhoneNumber = React.lazy(() => import("../container/AddPhoneNumber/AddPhoneNumber"));
const AddPhoneNumber_v5 = React.lazy(() => import("../container/V5/PhoneNumbers/AddPhoneNumber"));
const EditAgentUser = React.lazy(() => import("../container/EditAgentUser/EditAgentUser"));
const EditDepartmentUser = React.lazy(() => import("../container/EditDepartmentUser/EditDepartmentUser"));
const EditPhoneNumber = React.lazy(() => import("../container/EditPhoneNumber/EditPhoneNumber"));
const EditPhoneNumber_v5 = React.lazy(() => import("../container/V5/PhoneNumbers/PhoneNumberTable/EditPhoneNumber"));
const AddOutBound = React.lazy(() => import("../container/AddOutbound/AddOutbound"));
const AddE99 = React.lazy(() => import('../container/AddE99/AddE99'));
const EditAddon = React.lazy(() => import("../container/EditAddonData/EditAddon"));
const AddTicket = React.lazy(() => import("../container/AddTicket/AddTicket"));
const AddBlockedip = React.lazy(() => import("../container/AddBlockedIp/AddBlockedip"));
const AddWhiteList = React.lazy(() => import("../container/AddWhiteList/AddWhiteList"));
const EditWhiteList = React.lazy(() => import("../container/EditWhiteList/EditWhiteList"));
const AddInBoundProvider = React.lazy(() => import("../container/AddInbound/AddInBoundProvider"));
const EditInbound = React.lazy(() => import("../container/EditInbound/EditInbound"));
const AddIP = React.lazy(() => import("../container/AddInbound/AddIP"));
const ViewIp = React.lazy(() => import("../container/AddInbound/ViewIp"));
const EditIp = React.lazy(() => import("../container/EditInbound/EditIp"));
const Feedbacks = React.lazy(() => import("../container/Tickets/Feedbacks/Feedbacks"));
const AddSmsprovider = React.lazy(() => import("../container/Providers/Sms/addSmsprovider"));
const EditSmsProvider = React.lazy(() => import("../container/Providers/Sms/EditSmsProvider"));
const UpdateOutbound = React.lazy(() => import("../container/Providers/Outbound/UpdateOutbound"));
const UpdateE99 = React.lazy(() => import('../container/Providers/E99Provider/UpdateE99'));
const RateSheets = React.lazy(() => import("../container/Providers/Outbound/RateSheets"));
const RateSheets_Iristel = React.lazy(() => import("../container/PhoneNumbersNew/UploadIristelsheet"));
const AddVoiceRate = React.lazy(() => import("../container/Providers/Outbound/AddVoiceRate"));
const EditVoiceRate = React.lazy(() => import("../container/Providers/Outbound/EditVoiceRate"));
const PortPhoneNumber = React.lazy(() => import("../container/PhoneNumbers/PortPhoneNumber"));
const PortPhoneNumber_V5 = React.lazy(() => import("../container/V5/PhoneNumbers/PortPhoneNumber"));
const PuchasePhoneNumber = React.lazy(() => import("../container/PhoneNumbers/PurchasePhoneNumber"));
const BuyPhoneNumber = React.lazy(() => import("../container/PhoneNumbers/BuyPhoneNumber"));
const PortChangeData = React.lazy(() => import("../container/PhoneNumbers/PortChangeData"));
const Permissions = React.lazy(() => import("../container/Permission/permission"));
const deviceProvisions = React.lazy(() => import("../container/DeviceProvisions/index"));
const AddDeviceProvision = React.lazy(() => import("../container/DeviceProvisions/AddDeviceProvision"));
const EditDeviceProvision = React.lazy(() => import("../container/DeviceProvisions/EditDeviceProvision"));
const profile = React.lazy(() => import("../container/Profiles/profile"));
const AddProfile = React.lazy(() => import("../container/Profiles/AddProfile"));
const EditProfile = React.lazy(() => import("../container/Profiles/EditProfile"));
const provisionTextFile = React.lazy(() => import("../container/DeviceProvisions/provisionTextFile"));
const RateSheetData = React.lazy(() => import("../container/Providers/Outbound/RateSheetData"));
const Forgetpassword = React.lazy(() => import('../components/Header-component/ForgetPassword/ForgotPassword'));
const ForgotPassword = React.lazy(() => import("../components/Header-component/ForgetPassword/ForgotPassword"));
const LoginError = React.lazy(() => import("../container/Reports/LoginErrorPage/index"));
const LoginActivities = React.lazy(() => import("../container/Reports/LoginActivitiesPage/index"));
const AvailableNumber = React.lazy(() => import("../container/ClientUpdate/components/AvailableNumber"));
const UnassignNumber = React.lazy(() => import("../container/ClientUpdate/components/UnassignNumber"));
const AddDevice = React.lazy(() => import("../container/Security/SyncSettings/AddDevice"));
const UpdateDevice = React.lazy(() => import("../container/Security/SyncSettings/UpdateDevice"));
const SyncSetting = React.lazy(() => import('../container/Security/SyncSettings/SyncSettings/index'));
const AreaCode = React.lazy(() => import('../container/Providers/AreaCodes/AreaCode'));
const CountryAreaCode = React.lazy(() => import('../container/Providers/AreaCodes/CountryAreaCode'));

const MissingAreaCodes = React.lazy(() => import('../container/Providers/AreaCodes/missingAreacodes'));

const Addcountry = React.lazy(() => import("../container/Providers/AreaCodes/AddCountry/Addcountry"));
const UpdateCountry = React.lazy(() => import("../container/Providers/AreaCodes/UpdateCountry/UpdateCountry"));
const CountryArea = React.lazy(() => import('../container/Providers/AreaCodes/CountryAreas/countryArea'));
const AddArea = React.lazy(() => import('../container/Providers/AreaCodes/CountryAreas/AddArea/AddArea'));
const UpdateArea = React.lazy(() => import("../container/Providers/AreaCodes/CountryAreas/UpdateArea/updateArea"));
const IvrSpecialNumbers = React.lazy(() => import('../container/Security/IVRspecialnos/Ivrspecialnos'));
const UploadAreaCode = React.lazy(() => import("../container/Providers/AreaCodes/CountryAreas/UploadAreaCode"));
const Suggestions = React.lazy(() => import("../container/Tickets/Suggestions/suggestions"));
const Addsuggestion = React.lazy(() => import("../container/Tickets/Suggestions/AddSuggestion/Addsuggestion"));
const EditSuggestion = React.lazy(() => import("../container/Tickets/Suggestions/EditSuggestion/EditSuggestion"));
const Comments = React.lazy(() => import("../container/Tickets/Suggestions/Comments/Comments"));
const DeviceProvisionLogs = React.lazy(() => import("../container/Reports/DeviceProvisionLogs/DeviceProvisionLogs"));
const Reviews = React.lazy(() => import("../container/Tickets/Reviews/Reviews"));
const AddFeedback = React.lazy(() => import("../container/Tickets/Feedbacks/AddFeedback/AddFeedback"));
const EditFeedback = React.lazy(() => import("../container/Tickets/Feedbacks/EditFeedback"));
const Billing = React.lazy(() => import("../container/Billing/Billing"));
const AddTemplate = React.lazy(() => import("../container/Billing/EmailTemplates/AddTemplate"));
const EditTemplate = React.lazy(() => import("../container/Billing/EmailTemplates/EditTemplate"));
const AddVersion = React.lazy(() => import("../container/AddVersion/AddVersion"));
const EditAppVersion = React.lazy(() => import("../container/Security/EditAppVersion"));
const ValidateNumber = React.lazy(() => import("../container/PhoneNumbers/ValidateNumbersList/index"));
const Routing = React.lazy(() => import("../container/Providers/PerformanceRouting/Routing"));
const BlockedNumbers = React.lazy(() => import("../container/Security/BlockedNumbers/BlockedNumbers"));
const AddBlockedNumber = React.lazy(() => import("../container/Security/BlockedNumbers/AddBlockedNumber"));
const Invoice = React.lazy(() => import("../container/Billing/Invoices/Invoice"));
const Disputes = React.lazy(() => import("../container/Billing/Disputes/Disputes"));
const SignupActivations = React.lazy(() => import("../container/Billing/SignupActivations/SignupActivations"));
const AddonsBusiness = React.lazy(() => import("../container/Business/AddonsBusiness/AddonsBusiness"));
const AddBusinessAddons = React.lazy(() => import("../container/Business/AddonsBusiness/AddBusinessAddons"));
const EditBusinessAddons = React.lazy(() => import("../container/Business/AddonsBusiness/EditBusinessAddon"));
const AddonSummary = React.lazy(() => import("../container/Billing/AddonSummary/AddonSummary"));
const Business = React.lazy(() => import("../container/Business/Business"));
const AddAccount = React.lazy(() => import("../container/Business/AddAccount/AddAccount"));
const EditAccount = React.lazy(() => import("../container/Business/EditAccount/EditAccount"));
const AssignNumberEdit = React.lazy(() => import("../container/PhoneNumbers/PhoneNumberTable/AssignNumberEdit"));
const AssignNumbers = React.lazy(() => import("../container/Business/AssignNumbers/AssignNumbers"));
const BusinessInvoices = React.lazy(() => import("../container/Business/Invoices/BusinessInvoices"));
const BusinessDisputes = React.lazy(() => import("../container/Business/BusinessDisputes/BusinessDisputes"));
const BusinessAddonSummary = React.lazy(() => import("../container/Business/BusinessAddonSummary/BusinessAddonSummary"));
const BusinessSignupActivations = React.lazy(() => import("../container/Business/BusinessSignupActivations/BusinessSignupActivations"));
const Licenses = React.lazy(() => import("../container/Business/Licenses/Licenses"));
const AddLicense = React.lazy(() => import("../container/Business/Licenses/AddLicense"));
const BlockSettings = React.lazy(() => import("../container/Settings/BlockSettings/BlockSettings"));
const FreeTrial = React.lazy(() => import("../container/Settings/FreeTrial/FreeTrial"));
const ClientDefaultSettings = React.lazy(() => import("../container/Settings/ClientDefaultSettings/ClientDefaultSettings"));
const FreeTrialSignups = React.lazy(() => import("../container/Billing/FreeTrialSignups/FreeTrialSignups"));
const Clients = React.lazy(() => import("../container/InternationalCalling/Clients/Clients"));
const Settings = React.lazy(() => import("../container/InternationalCalling/Settings/Settings"));
const Reportss = React.lazy(() => import("../container/InternationalCalling/Reports/Reports"));
const AddFlashScreen = React.lazy(() => import("../container/InternationalCalling/Settings/FlashScreen/AddFlashScreen"));
const AddIcUser = React.lazy(() => import('../container/InternationalCalling/Clients/addIcUser'));
const IcClientUpdates = React.lazy(() => import("../container/InternationalCalling/Clients/IcClientUpdates"));
const Notifications = React.lazy(() => import("../container/InternationalCalling/Notifications/Notifications"));
const AddMobileNotication = React.lazy(() => import("../container/InternationalCalling/Notifications/MobileNotifications/AddMobileNotication"));
const AddEmailNotification = React.lazy(() => import("../container/InternationalCalling/Notifications/EmailNotifications/AddEmailNotification"));
const NotificationUpdates = React.lazy(() => import("../container/InternationalCalling/Notifications/MobileNotifications/UpdateNotification"));
const LoginNotification = React.lazy(() => import("../container/InternationalCalling/Notifications/MobileNotifications/NotificationLogs/LogsNotification"));
const AddonReports = React.lazy(() => import("../container/Reports/AddonReports/AddonReports"));
const Dashboardd = React.lazy(() => import('../container/InternationalCalling/Dashboard/Dashboard'));
const Packages = React.lazy(() => import("../container/InternationalCalling/Packages/Packages"));
const AddPackage = React.lazy(() => import("../container/InternationalCalling/Packages/AddPackage"));
const UpdatePackag = React.lazy(() => import("../container/InternationalCalling/Packages/UpdatePackag"));
const UpdateEmailNotifications = React.lazy(() => import("../container/InternationalCalling/Notifications/EmailNotifications/UpdateEmailNotifications"));
const EmailTrigger = React.lazy(() => import('../container/Settings/Email Trigger/EmailTrigger'));
const AddEmailTriggers = React.lazy(() => import('../container/Settings/Email Trigger/AddEmailTriggers'));
const EditEmailTriggers = React.lazy(() => import('../container/Settings/Email Trigger/EditEmailTriggers'));
const Features = React.lazy(() => import("../container/V5/Features/Features"));
const BasicInfo = React.lazy(() => import("../container/V5/Features/AddFearute.tsx/BasicInfo/BasicInfo"));
const ImagesVideos = React.lazy(() => import("../container/V5/Features/AddFearute.tsx/Images&videos/ImagesVideos"));
const Seo = React.lazy(() => import("../container/V5/Features/AddFearute.tsx/Seo/Seo"));
const Pricing = React.lazy(() => import("../container/V5/Features/AddFearute.tsx/Pricing/Pricing"));
const Display = React.lazy(() => import("../container/V5/Features/AddFearute.tsx/Display/Display"));
const Users = React.lazy(() => import("../container/V5/Users/Users"));
const Settingss = React.lazy(() => import('../container/V5/Settings/Settings'));
const SpecialRouting = React.lazy(() => import("../container/V5/SpecialRouting/SpecialRouting"));
const AddSpecialRouting = React.lazy(() => import("../container/V5/SpecialRouting/AddRouting/AddRouting"));
const AddUsers = React.lazy(() => import('../container/V5/Users/AddUser/AddUser'));
const V5Clients = React.lazy(() => import("../container/V5/Clients/Clients"));
const CallRate = React.lazy(() => import("../container/V5/CallRate/CallRate"));
const V5ClientsReports = React.lazy(() => import("../container/V5/Reports/Reports"));
const UserLifecycleReport = React.lazy(() => import("../container/V5/Reports/UserLifecycle/UserLifecycleReport"));
const V5UnassignNumber = React.lazy(() => import("../container/V5/Clients/UnassignNumber"));
const Plans = React.lazy(() => import("../container/V5/Plans/Plans"));
const AddPlan = React.lazy(() => import("../container/V5/Plans/AddPlan/AddPlan"));
const AddClient = React.lazy(() => import("../container/V5/Clients/AddClient/AddClient"));
const EditPlan = React.lazy(() => import("../container/V5/Plans/EditPlan"));
const EditUser = React.lazy(() => import('../container/V5/Users/EditUser'));
const RatesViaEmail = React.lazy(() => import("../container/Providers/RatesViaEmail/RatesViaEmail"));
const AddQualityRouteSettings = React.lazy(() => import("../container/Providers/QualityRouteSettings/AddQualityRouteSettings"));
const EditQualityRouteSettings = React.lazy(() => import("../container/Providers/QualityRouteSettings/EditQualityRouteSettings"));
const ProvidersVendorReports = React.lazy(() => import("../container/Providers/VendorReports/VendorReports"));
const UsersAddonSummary = React.lazy(() => import("../container/Providers/VendorReports/AddonSummary"));
const CallsReports = React.lazy(() => import("../container/Reports/vendorReports/CallsReports"));
const AddNewQualitySettings = React.lazy(() => import("../container/Providers/NewQualitySettings/AddNewQualitySettings"));
const EditNewQualitySettings = React.lazy(() => import("../container/Providers/NewQualitySettings/EditNewQualitySettings"));
const UserReports = React.lazy(() => import("../container/Providers/UserReports/UserReports"));
const EditLicense = React.lazy(() => import("../container/Business/Licenses/EditLicense"));
const Subsciption = React.lazy(() => import("../container/V5/subscription/SpecialRouting"));
const Subscriptions = React.lazy(() => import("../container/V5/Clients/Details/components/Subscriptions"));
const SubscriptionsPage = React.lazy(() => import("../container/V5/subscription/Subscriptions"));
const ElevenOne = React.lazy(() => import("../container/V5/E911/ElevenOne"));
const v5Dashboard = React.lazy(() => import("../container/V5/Dashboard/Dashboard"));
const MasterPrefixes = React.lazy(() => import("../container/Providers/Outbound/MasterPrefixes"));
const competitorRates = React.lazy(() => import("../container/Providers/Outbound/competitorRates"));
const HomePhoneProducts = React.lazy(() => import("../container/V5/HomePhones/HomePhoneProducts"));
const ProductForm = React.lazy(() => import("../container/V5/HomePhones/ProductForm"));
const ProductDetails = React.lazy(() => import("../container/V5/HomePhones/ProductDetails"));
const HomePhoneOrders = React.lazy(() => import("../container/V5/HomePhones/HomePhoneOrders"));
const OrderDetails = React.lazy(() => import("../container/V5/HomePhones/OrderDetails"));
const PushCampaigns = React.lazy(() => import("../container/V5/PushCampaigns/PushCampaigns"));

const terminationCallReport = React.lazy(() => import("../container/Providers/Outbound/terminationCallReport"));

const routes = [
  {
    path: "/dashboard",
    Title: "Dashboard",
    //Component: Dashboard,
    Component: v5Dashboard,
    routes: []
  },
  {
    path: "/v4-dashboard",
    Title: "Dashboard",
    Component: Dashboard,
    routes: []
  },
  {
    path: "/permissions/:id",
    Title: "Permssions",
    Component: Permissions,
    routes: [],
    // crud_name : "list",
    // permission_index:3,
    // permission_name:"profiles",
  },

  {
    path: "/efone-clients",
    Title: "Efone clients",
    Component: EfoneClients,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },

  {
    path: "/licenses",
    Title: "Licenses",
    Component: Licenses,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/add-licenses",
    Title: "Add License",
    Component: AddLicense,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/edit-license/:id",
    Title: "Edit License",
    Component: EditLicense,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/business",
    Title: "Clients",
    Component: Business,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/business-invoices",
    Title: "Invoices",
    Component: BusinessInvoices,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/business-disputes",
    Title: "Disputes",
    Component: BusinessDisputes,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/business-signup-activations",
    Title: "Signup Activations",
    Component: BusinessSignupActivations,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/business-addonsummary",
    Title: "Addon Summary",
    Component: BusinessAddonSummary,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/business-addons",
    Title: "Addons",
    Component: AddonsBusiness,
    routes: [],
  },
  {
    path: "/business-addAddons",
    Title: "Add user",
    Component: AddBusinessAddons,
    routes: [],
    // crud_name : "add",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/business-editAddons/:id",
    Title: "Edit user",
    Component: EditBusinessAddons,
    routes: [],
    // crud_name : "add",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/addaccount",
    Title: "Addaccount",
    Component: AddAccount,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/editbusinessaccount/:id",
    Title: "Update business Account",
    Component: EditAccount,
    routes: [],
  },
  // {
  //   path: "/international-calling",
  //   Title:'International Calling',
  //   Component: InternationalCalling,
  // },
  {
    path: "/international-calling/dashboard",
    Title: 'Dashboard',
    Component: Dashboardd,
  },
  {
    path: "/international-calling/clients",
    Title: 'Clients',
    Component: Clients,
  },
  {
    path: "/international-calling/packages",
    Title: 'Packages',
    Component: Packages,
  },
  {
    path: "/international-calling/addpackage",
    Title: 'Packages',
    Component: AddPackage,
  },
  {
    path: "/international-calling/updatePackage/:id",
    Title: "Packages",
    Component: UpdatePackag,
    routes: []
  },
  {
    path: "/international-calling/reports",
    Title: 'Reports',
    Component: Reportss,
  },
  {
    path: "/international-calling/settings",
    Title: 'Settings',
    Component: Settings,
  },
  {
    path: "/international-calling/addflashscreen",
    Title: 'Add Flash Screen',
    Component: AddFlashScreen,
  },
  {
    path: "/international-calling/addICUser",
    Title: "AddClient",
    Component: AddIcUser,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/international-calling/ClientUpdates/:id",
    Title: "ClientUpdates",
    Component: IcClientUpdates,
    routes: []
  },
  {
    path: "/international-calling/notifications",
    Title: 'Notifications',
    Component: Notifications
  },
  {
    path: "/international-calling/logsnotification/logs/:id",
    Title: 'Notification',
    Component: LoginNotification
  },
  {
    path: "/international-calling/notification/addmobilenotificaton",
    Title: 'Notifications',
    Component: AddMobileNotication
  },
  {
    path: "/international-calling/notification/updatenotification/:id",
    Title: 'Update Notifications',
    Component: NotificationUpdates
  },
  {
    path: "/international-calling/notification/addemailnotification",
    Title: 'Notifications',
    Component: AddEmailNotification
  },
  {
    path: "/international-calling/notification/updateEmailnotification/:id",
    Title: 'Update Email Notifications',
    Component: UpdateEmailNotifications
  },
  {
    path: "/efone-clients/:id",
    Title: "Efone clients",
    Component: EfoneClients,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/availableNumber/:id",
    Title: "Available Numbers",
    Component: AvailableNumber,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/assignNumbers/:id",
    Title: "Assign Numbers",
    Component: AssignNumbers,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/validate_numbers/:id",
    Title: "Validate Numbers",
    Component: ValidateNumber,
    routes: [],
  },
  {
    path: "/unassignNumber/:id",
    Title: "Unassign Numbers",
    Component: UnassignNumber,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/v5/dashboard",
    Title: "Dashboard - v5",
    Component: v5Dashboard,
    routes: [],
  },
  {
    path: "/v5/unassignNumber/:id",
    Title: "Unassign Numbers",
    Component: V5UnassignNumber,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/agents",
    Title: "Agents",
    Component: Agents,
    routes: [],
    // crud_name : "list",    
    // permission_index:1,
    // permission_name:"agents",
  },
  {
    path: "/departments",
    Title: "Departments",
    Component: Departments,
    routes: [],
    // crud_name : "list",    
    // permission_index:2,
    // permission_name:"departments",
  },
  {
    path: "/profiles",
    Title: "Profiles",
    Component: profile,
    routes: [],
    // crud_name : "list",    
    // permission_index:3,
    // permission_name:"profiles",
  },
  {
    path: "/add-profiles",
    Title: "Add Profiles",
    Component: AddProfile,
    routes: [],
    // crud_name : "add",    
    // permission_index:3,
    // permission_name:"profiles",
  },
  {
    path: "/edit-profiles/:id",
    Title: "Add Profiles",
    Component: EditProfile,
    routes: [],
    // crud_name : "edit",    
    // permission_index:3,
    // permission_name:"profiles",
  },
  {
    path: "/adminusers/addportal-user",
    Title: "Add Portal User",
    Component: AddPortalUser,
    routes: [],
    // crud_name : "add",    
    // permission_index:1,
    // permission_name:"agents",
  },
  {
    path: "/adminusers/editportal-user/:clientId",
    Title: "Edit Portal User",
    Component: EditAgentUser,
    routes: [],
    // crud_name : "edit",    
    // permission_index:1,
    // permission_name:"agents",
  },
  {
    path: "/adminusers/adddepartment",
    Title: "Add Department",
    Component: AddDepartment,
    routes: [],
    // crud_name : "add",    
    // permission_index:2,
    // permission_name:"departments",
  },
  {
    path: "/adminusers/editdepartment/:clientId",
    Title: "Edit Department",
    Component: EditDepartmentUser,
    routes: [],
    // crud_name : "edit",    
    // permission_index:2,
    // permission_name:"departments",
  },
  {
    path: "/phone-numbers",
    Title: "Phone Numbers",
    Component: PhoneNumbers,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/phone-numbers-new",
    Title: "Phone Numbers New",
    Component: PhoneNumbersNew,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/v5/phone-numbers",
    Title: "Phone Numbers",
    Component: V5PhoneNumbers,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/phonenumbers/v5/editPhoneNumber/:id",
    Title: "Edit Phone Numbers",
    Component: EditPhoneNumber_v5,
    routes: [],
    // crud_name : "edit",    
    // permission_index:4,
    // permission_name:"phoneNumbers",
  },
  {
    path: "/phonenumbers/v5/editAssignphone/:id",
    Title: "Edit Assign Numbers",
    Component: AssignNumberEdit_v5,
    routes: [],
    // crud_name : "edit",    
    // permission_index:4,
    // permission_name:"phoneNumbers",
  },
  {
    path: "/v5/add-purchase-numbers",
    Title: "Phone Numbers",
    Component: V5PhoneNumbersList,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/phonenumbers/addphoneNumber",
    Title: "Add Phone Number",
    Component: AddPhoneNumber,
    routes: [],
    // crud_name : "list",    
    // permission_index:4,
    // permission_name:"phoneNumbers",
  },
  {
    path: "/v5/phonenumbers/addphoneNumber",
    Title: "Add Phone Number",
    Component: AddPhoneNumber_v5,
    routes: [],
    // crud_name : "list",    
    // permission_index:4,
    // permission_name:"phoneNumbers",
  },
  {
    path: "/phone/portNumber",
    Title: "Add Phone Number",
    Component: PortPhoneNumber,
    routes: [],
    // crud_name : "port",    
    // permission_index:4,
    // permission_name:"phoneNumbers",
  },
  {
    path: "/v5/phone/portNumber/:phoneNumberId",
    Title: "Add Phone Number",
    Component: PortPhoneNumber_V5,
    routes: [],
    // crud_name : "port",    
    // permission_index:4,
    // permission_name:"phoneNumbers",
  },
  {
    path: "/phonenumbers/portNumber/:clientId",
    Title: "Add Phone Number",
    Component: PortChangeData,
    routes: [],
    // crud_name : "port",    
    // permission_index:4,
    // permission_name:"phoneNumbers",
  },
  {
    path: "/phonenumbers/purchaseNumber",
    Title: "Purchase Phone Number",
    Component: PuchasePhoneNumber,
    routes: [],
    // crud_name : "purchase",    
    // permission_index:4,
    // permission_name:"phoneNumbers",
  },
  // {
  //   path: "/phonenumbers/buyNumber/:id/:number/:state/:rateCenter/:setupRate/:monthlyRate/:perMinuteRate",
  //   Title: "Buy Phone Number",
  //   Component: BuyPhoneNumber,
  //   routes: [],
  //   // crud_name : "purchase",    
  //   // permission_index:4,
  //   // permission_name:"phoneNumbers",
  // },
  {
    path: "/phonenumbers/buyNumber/:number/:state/:rateCenter/:tier/:vendorId/:vendorName",
    Title: "Buy Phone Number",
    Component: BuyPhoneNumber,
    routes: [],
    // crud_name : "purchase",    
    // permission_index:4,
    // permission_name:"phoneNumbers",
  },
  {
    path: "/v5/phonenumbers/buyNumber/:number/:state/:rateCenter/:didId",
    Title: "Buy Phone Number",
    Component: BuyPhoneNumber_v5,
    routes: [],
    // crud_name : "purchase",    
    // permission_index:4,
    // permission_name:"phoneNumbers",
  },
  {
    path: "/phonenumbers/editphoneNumber/:clientId",
    Title: "Edit Phone Numbers",
    Component: EditPhoneNumber,
    routes: [],
    // crud_name : "edit",    
    // permission_index:4,
    // permission_name:"phoneNumbers",
  },
  {
    path: "/phonenumbers/editAssignphone/:id",
    Title: "Edit Assign Numbers",
    Component: AssignNumberEdit,
    routes: [],
    // crud_name : "edit",    
    // permission_index:4,
    // permission_name:"phoneNumbers",
  },
  {
    path: "/performance_routing",
    Title: "Performance Routing",
    Component: Routing,
    routes: [],
    // crud_name : "list",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/outbound-providers",
    Title: "Outbound",
    Component: Outbound,
    routes: [],
    // crud_name : "list",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/outbound/prefix-alerts-block/settings/",
    Title: "Prefix Alerts & Block Settings",
    Component: listPrefixAlertsBlockSettings,
    routes: [],
    // crud_name : "list",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/outbound/master-prefixes/",
    Title: "Provider Master Prefixes",
    Component: MasterPrefixes,
    routes: [],
    // crud_name : "list",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },

  {
    path: "/outbound/competitor-rates/",
    Title: "Competitor rates",
    Component: competitorRates,
    routes: [],
    // crud_name : "list",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },

  {
    path: "/outbound/termination-call-report/",
    Title: "Termination Report",
    Component: terminationCallReport,
    routes: [],
  },

  {
    path: "/outbound/create-prefix-alerts-block/settings/",
    Title: "Prefix Alerts & Block Settings",
    Component: createPrefixAlertsBlockSettings,
    routes: [],
    // crud_name : "list",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/providers/vendorReports/calls",
    Title: "Calls",
    Component: CallsReports,
    routes: [],
  },
  {
    path: "/providers/vendor-reports/:type",
    Title: "Vendor Reports",
    Component: ProvidersVendorReports,
    routes: [],
    // crud_name : "list",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/addons-summary-reports/:id",
    Title: "Addon Summary",
    Component: UsersAddonSummary,
    routes: [],
    // crud_name : "list",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/providers/user-reports",
    Title: "User Reports",
    Component: UserReports,
    routes: [],
    // crud_name : "list",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/queue/:id",
    Title: "Queue",
    Component: QueueDetails,
    routes: [],
    // crud_name : "list",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/e911Provider",
    Title: "E911provider",
    Component: E911provider,
    routes: [],
    // crud_name : "list",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/out-bound/add-outbound",
    Title: "Add Outbound",
    Component: AddOutBound,
    routes: [],
    // crud_name : "add",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/e911/add-E911",
    Title: "Add E99",
    Component: AddE99,
    routes: [],
    // crud_name : "list",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/E99update/:Id",
    Title: " E99 Update",
    Component: UpdateE99,
    routes: [],
    // crud_name : "edit",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/update/:Id",
    Title: " Outbound Update",
    Component: UpdateOutbound,
    routes: [],
    // crud_name : "edit",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/rates-via-email",
    Title: " Rates via email",
    Component: RatesViaEmail,
    routes: [],
    // crud_name : "edit",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/add-voiceRate",
    Title: " Outbound Update",
    Component: AddVoiceRate,
    routes: [],
    // crud_name : "edit",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/edit-voiceRate/:ID/edit/:id",
    Title: " Outbound Update",
    Component: EditVoiceRate,
    routes: [],
    // crud_name : "edit",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/upload_sheet/:id",
    Title: " Update Rate Sheet",
    Component: RateSheets,
    routes: [],
    // crud_name : "edit",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/upload_ratesheet/iristelNumber",
    Title: " Update Rate Sheet",
    Component: RateSheets_Iristel,
    routes: [],
    // crud_name : "edit",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/rate_sheet_data/:id",
    Title: " Rate Sheet Data",
    Component: RateSheetData,
    routes: [],
    // crud_name : "edit",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/inbound-providers",
    Title: "Inbound",
    Component: Inbound,
    routes: [],
    // crud_name : "list",    
    // permission_index:6,
    // permission_name:"inboundProviders",
  },
  {
    path: "/addInbound/Provider",
    Title: "Add Inbound",
    Component: AddInBoundProvider,
    routes: [],
    // crud_name : "add",    
    // permission_index:6,
    // permission_name:"inboundProviders",
  },
  {
    path: "/in-bound/editInbound/:Id",
    Title: "Inbound",
    Component: EditInbound,
    routes: [],
    // crud_name : "edit",    
    // permission_index:6,
    // permission_name:"inboundProviders",
  },
  {
    path: "/in-bound/addIP/:ID",
    Title: "Inbound",
    Component: AddIP,
    routes: [],
    // crud_name : "list",    
    // permission_index:6,
    // permission_name:"inboundProviders",
  },
  {
    path: "/in-bound/viewIP/:Id",
    Title: "View Inbound",
    Component: ViewIp,
    routes: [],
    // crud_name : "list",    
    // permission_index:6,
    // permission_name:"inboundProviders",
  },
  {
    path: "/in-bound/editIP/:Id/editIp/:id",
    Title: "View Inbound",
    Component: EditIp,
    routes: [],
    // crud_name : "list",    
    // permission_index:6,
    // permission_name:"inboundProviders",
  },
  {
    path: "/sms-providers",
    Title: "SMS",
    Component: Sms,
    routes: [],
    // crud_name : "list",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/AddSms",
    Title: "SMS",
    Component: AddSmsprovider,
    routes: [],
    // crud_name : "add",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/countryCode",
    Title: "Country code",
    Component: AreaCode,
    routes: [],
    // crud_name : "add",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/areaCodes/:id",
    Title: "Area codes",
    Component: CountryAreaCode,
    routes: [],
    // crud_name : "add",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/missing-areacodes/:id",
    Title: "Missig Area codes",
    Component: MissingAreaCodes,
    routes: [],
    // crud_name : "add",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/countryArea/:id",
    Title: "Areas code",
    Component: CountryArea,
    routes: [],
    // crud_name : "add",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/upload_areacode/:id",
    Title: " Update Area Code",
    Component: UploadAreaCode,
    routes: [],
    // crud_name : "edit",    
    // permission_index:5,
    // permission_name:"outboundProviders",
  },
  {
    path: "/addarea/:id",
    Title: "Areas code",
    Component: AddArea,
    routes: [],
    // crud_name : "add",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/addCountry",
    Title: "Add Country",
    Component: Addcountry,
    routes: [],
    // crud_name : "add",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/ivr_special_numbers",
    Title: "IVR & Special Numbers",
    Component: IvrSpecialNumbers,
    routes: [],
    // crud_name : "add",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/blocked_numbers",
    Title: "Blocked Numbers",
    Component: BlockedNumbers,
    routes: [],
    // crud_name : "add",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/addblockednumbers",
    Title: "Add Blocked Numbers",
    Component: AddBlockedNumber,
    routes: [],
    // crud_name : "add",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/device-provision-logs",
    Title: "Device Provision Logs",
    Component: DeviceProvisionLogs,
    routes: [],
    // crud_name : "add",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/updateCountry/:id",
    Title: "Update Country",
    Component: UpdateCountry,
    routes: [],
    // crud_name : "add",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/updateArea/:id/:val",
    Title: "Update Area",
    Component: UpdateArea,
    routes: [],
    // crud_name : "add",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/EditSms/:ID",
    Title: "SMS",
    Component: EditSmsProvider,
    routes: [],
    // crud_name : "edit",    
    // permission_index:7,
    // permission_name:"smsProviders",
  },
  {
    path: "/add-ons",
    Title: "Add Ons",
    Component: Addons,
    routes: [],
    // crud_name : "list",    
    // permission_index:8,
    // permission_name:"addons",
  },
  {
    path: "/tickets",
    Title: "Tickets",
    Component: Tickets,
    routes: [],
    // crud_name : "list",    
    // permission_index:9,
    // permission_name:"tickets",
  },
  {
    path: "/addTicket",
    Title: "Add Tickets",
    Component: AddTicket,
    routes: [],
    // crud_name : "add",    
    // permission_index:9,
    // permission_name:"tickets",
  },
  {
    path: "/reviews",
    Title: "Reviews",
    Component: Reviews,
    routes: [],
    // crud_name : "add",    
    // permission_index:9,
    // permission_name:"tickets",
  },
  {
    path: "/suggestions",
    Title: "Suggestions",
    Component: Suggestions,
    routes: [],
    // crud_name : "add",    
    // permission_index:9,
    // permission_name:"tickets",
  },
  {
    path: "/addsuggestion",
    Title: "Add Suggestion",
    Component: Addsuggestion,
    routes: [],
  },
  {
    path: "/editsuggestion/:id",
    Title: "Edit Suggestion",
    Component: EditSuggestion,
    routes: [],
  },
  {
    path: "/reports",
    Title: "Client Reports",
    Component: Reports,
    routes: [],
  },
  {
    path: "/v5/reports/user-lifecycle",
    Title: "User Lifecycle Report",
    Component: UserLifecycleReport,
    routes: [],
  },
  {
    path: "/v5/reports/:report_type(calls|sms|addons_usage)",
    Title: "V5 Reports",
    Component: V5ClientsReports,
    routes: [],
  },
  {
    path: "/loginError/:option",
    Title: "Login Errors",
    Component: LoginError,
    routes: [],
  },

  {
    path: "/loginActivities/:option",
    Title: "Login Activities",
    Component: LoginActivities,
    routes: [],
  },

  {
    path: "/addons",
    Title: "Addon Reports",
    Component: AddonReports,
    routes: [],
  },


  {
    path: "/feedback",
    Title: "Feedback",
    Component: Feedbacks,
    routes: [],
  },
  {
    path: "/addfeedback",
    Title: "Add Feedback",
    Component: AddFeedback,
    routes: [],
  },
  {
    path: "/editfeedback/:id",
    Title: "Edit Feedback",
    Component: EditFeedback,
    routes: [],
    // crud_name : "edit",    
    // permission_index:16,
    // permission_name:"deviceProvisions",
  },
  {
    path: "/security",
    Title: "Security",
    Component: Security,
    routes: [],
  },
  {
    path: "/logs_settings",
    Title: "Block Settings",
    Component: BlockSettings,
    routes: [],
  },
  {
    path: "/security/:option",
    Title: "Security",
    Component: Security,
    routes: [],
  },
  {
    path: "/addDevice",
    Title: "Add Device",
    Component: AddDevice,
    routes: [],
  },
  {
    path: "/addTemplates",
    Title: "Add Email Template",
    Component: AddTemplate,
    routes: [],
  },
  {
    path: "/billing",
    Title: "Billing",
    Component: Billing,
    routes: [],
  },
  {
    path: "/invoices",
    Title: "Invoice",
    Component: Invoice,
    routes: [],
  },
  {
    path: "/disputes",
    Title: "Disputes",
    Component: Disputes,
    routes: [],
  },
  {
    path: "/signup-activations",
    Title: "Signup Activations",
    Component: SignupActivations,
    routes: [],
  },
  {
    path: "/addon-summary",
    Title: "Addon Summary",
    Component: AddonSummary,
    routes: [],
  },
  {
    path: "/updateDevice/:id",
    Title: "Update Device",
    Component: UpdateDevice,
    routes: [],
  },
  {
    path: "/editTemplate/:id",
    Title: "Update Template",
    Component: EditTemplate,
    routes: [],
  },
  {
    path: "/editAppVersion/:id",
    Title: "Update App Version",
    Component: EditAppVersion,
    routes: [],
  },
  {
    path: "/syncSettings/:id",
    Title: "Sync Setting",
    Component: SyncSetting,
    routes: [],
  },
  {
    path: "/deviceProvision",
    Title: "Device Provision",
    Component: deviceProvisions,
    routes: [],
    // crud_name : "list",    
    // permission_index:16,
    // permission_name:"deviceProvisions",
  },
  {
    path: "/addDeviceProvision",
    Title: "Add Device Provision",
    Component: AddDeviceProvision,
    routes: [],
    // crud_name : "add",    
    // permission_index:16,
    // permission_name:"deviceProvisions",
  },
  {
    path: "/editDeviceProvision/:id",
    Title: "Edit Device Provision",
    Component: EditDeviceProvision,
    routes: [],
    // crud_name : "edit",    
    // permission_index:16,
    // permission_name:"deviceProvisions",
  },
  {
    path: "/provisionData/:id",
    Title: "Provision",
    Component: provisionTextFile,
    routes: [],
    // crud_name : "add",    
    // permission_index:16,
    // permission_name:"deviceProvisions",
  },
  {
    path: "/secure/addBlockedIp",
    Title: "Security Blocked IP",
    Component: AddBlockedip,
    routes: [],
    // crud_name : "add",    
    // permission_index:11,
    // permission_name:"blockedIPs",
  },
  {
    path: "/secure/addWhiteList",
    Title: "Security White List",
    Component: AddWhiteList,
    routes: [],
    // crud_name : "add",    
    // permission_index:12,
    // permission_name:"whiteIPs",
  },
  {
    path: "/secure/editWhiteList",
    Title: "Security White List",
    Component: EditWhiteList,
    routes: [],
    // crud_name : "edit",    
    // permission_index:12,
    // permission_name:"whiteIPs",
  },
  {
    path: "/clientUpdates/:clientId",
    Title: "Client Updates",
    Component: ClientUpdate,
    routes: [],
    // crud_name : "calls",    
    // permission_index:10,
    // permission_name:"reports",
  },
  {
    path: "/v5/client-details/:clientId",
    Title: "Client Details",
    Component: V5Client,
    routes: [],
    // crud_name : "calls",    
    // permission_index:10,
    // permission_name:"reports",
  },
  {
    path: "/addUser",
    Title: "Add user",
    Component: AddUser,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/addNewUser",
    Title: "Add user",
    Component: AddNewUser,
    routes: [],
    // crud_name : "add",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/editNewUser/:clientId",
    Title: "Edir user",
    Component: EditAddon,
    routes: [],
    // crud_name : "edit",    
    // permission_index:8,
    // permission_name:"addons",
  },
  // {
  //   path: "/vendor-reports",
  //   Title: "Vendor Reports",
  //   Component: VendorReports,
  //   routes: [],
  // },
  {
    path: "/usage-reports",
    Title: "Usage Reports",
    Component: UsageReports,
    routes: [],
  },
  {
    path: "/login-errors",
    Title: "Login Errors",
    Component: LoginError,
    routes: [],
  },
  {
    path: "/login-activities",
    Title: "Login Activities",
    Component: LoginActivities,
    routes: [],
  },
  {
    path: "/efone-support/:id",
    Title: "Efone Support",
    Component: EfoneSupport,
    routes: [],
    // crud_name : "edit",    
    // permission_index:9,
    // permission_name:"tickets",
  },
  {
    path: "/comments/:id",
    Title: "View Comments",
    Component: Comments,
    routes: [],
  },
  {
    path: "/secure/AddVersion",
    Title: "Add version",
    Component: AddVersion,
    routes: [],
  },
  {
    path: "/logout",
    Title: "Logout",
    Component: Logout,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/forgotPassword",
    Title: "Forget Password",
    Component: ForgotPassword,
    routes: [],
    // crud_name : "list",    
    // permission_index:0,
    // permission_name:"efoneClients",
  },
  {
    path: "/freetrial",
    Title: "FreeTrial",
    Component: FreeTrial,
  },
  {
    path: "/clientdefaultsetting",
    Title: "Client Default Setting",
    Component: ClientDefaultSettings,
  },
  {
    path: "/freetrialsignups",
    Title: "Free Trial Signups",
    Component: FreeTrialSignups,
  },
  {
    path: "/emailtriggers",
    Title: "EmailTrigger",
    Component: EmailTrigger,
  },
  {
    path: "/editemailtrigger/:id",
    Title: "Update Email Trigger",
    Component: EditEmailTriggers,
    routes: [],
  },

  {
    path: "/emailtrigger/addemailtrigger",
    Title: "Add EmailTrigger",
    Component: AddEmailTriggers,
  },


  //v5
  {
    path: "/v5/clients",
    Title: "Clients",
    Component: V5Clients,
    routes: [],
  },
  {
    path: "/v5/call-rates",
    Title: "Call Rates",
    Component: CallRate,
    routes: [],
  },
  {
    path: "/v5/push-campaigns/create",
    Title: "Create Push Campaign",
    Component: (props: any) => <PushCampaigns {...props} mode="create" />,
    routes: [],
  },
  {
    path: "/v5/push-campaigns/:campaignId/logs",
    Title: "Push Campaign Logs",
    Component: (props: any) => <PushCampaigns {...props} mode="logs" />,
    routes: [],
  },
  {
    path: "/v5/push-campaigns/:campaignId/edit",
    Title: "Edit Push Campaign",
    Component: (props: any) => <PushCampaigns {...props} mode="edit" />,
    routes: [],
  },
  {
    path: "/v5/push-campaigns/:campaignId",
    Title: "Push Campaign Detail",
    Component: (props: any) => <PushCampaigns {...props} mode="detail" />,
    routes: [],
  },
  {
    path: "/v5/push-campaigns",
    Title: "Push Campaigns",
    Component: PushCampaigns,
    routes: [],
  },
  {
    path: "/client/addClient",
    Title: "Plans",
    Component: AddClient,
    routes: [],
  },
  {
    path: "/plans",
    Title: "Plans",
    Component: Plans,
    routes: [],
  },
  {
    path: "/plan/addplan",
    Title: "Plans",
    Component: AddPlan,
    routes: [],
  },
  {
    path: "/plan/editplan/:id",
    Title: "Update Plan",
    Component: EditPlan,
    routes: [],
  },
  {
    path: "/features",
    Title: "Features",
    Component: Features,
    routes: [],
  },
  {
    path: '/featuress/basicinfo',
    Title: 'Add Feature',
    Component: BasicInfo,
    routes: [],
  },
  {
    path: '/featuress/basicinfoupdate/:id',
    Title: 'Add Feature',
    Component: BasicInfo,
    routes: [],
  },
  {
    path: '/featuress/imagesvideos/:id',
    Title: 'Add Feature',
    Component: ImagesVideos,
    routes: [],
  },
  {
    Title: 'Add Feature',
    path: '/featuress/seo/:id',
    Component: Seo,
    routes: [],
  },
  {
    path: '/featuress/pricing/:id',
    Title: 'Add Feature',
    Component: Pricing,
    routes: [],
  },
  {
    path: '/featuress/display/:id',
    Title: 'Add Feature',
    Component: Display,
    routes: [],
  },
  {
    path: '/users',
    Title: 'Users',
    Component: Users,
    routes: [],
  },
  {
    path: '/userss/adduser',
    Title: 'Users',
    Component: AddUsers,
  },
  {
    path: "/user/editUser/:id",
    Title: "Update User",
    Component: EditUser,
    routes: [],
  },
  {
    path: '/settings',
    Title: 'Settings',
    Component: Settingss,

    routes: [],
  },
  {
    path: '/e911',
    Title: 'E911',
    Component: ElevenOne,
    routes: [],
  },
  {
    path: '/subscriptions',
    Title: 'subscriptions',
    Component: SubscriptionsPage,
    routes: [],
  },
  {
    path: "/home-phones/products/create",
    Title: "Create Home Phone Product",
    Component: ProductForm,
    routes: [],
  },
  {
    path: "/home-phones/products/:id/edit",
    Title: "Edit Home Phone Product",
    Component: ProductForm,
    routes: [],
  },
  {
    path: "/home-phones/products/:id",
    Title: "Home Phone Product Details",
    Component: ProductDetails,
    routes: [],
  },
  {
    path: "/home-phones/products",
    Title: "Home Phone",
    Component: HomePhoneProducts,
    routes: [],
  },
  {
    path: "/home-phones/orders/:id",
    Title: "Home Phone Order Details",
    Component: OrderDetails,
    routes: [],
  },
  {
    path: "/home-phones/orders",
    Title: "Home Phone Orders",
    Component: HomePhoneOrders,
    routes: [],
  },
  {
    path: `/v5/specialRouting`,
    Title: 'Special Routing',
    Component: SpecialRouting,
    routes: [],
  },
  {
    path: `/v5/routing/addRouting`,
    Title: 'Special Routing',
    Component: AddSpecialRouting,
    routes: [],
  },
  {
    path: '/quality-route-settings/add',
    Title: 'Add Quality Route Settings',
    Component: AddQualityRouteSettings,
    routes: []
  },
  {
    path: '/quality-route-settings/edit/:id',
    Title: 'Edit Quality Route Settings',
    Component: EditQualityRouteSettings,
    routes: []
  },
  {
    path: '/new-quality-settings/add',
    Title: 'Add New Quality Settings',
    Component: AddNewQualitySettings,
    routes: []
  },
  {
    path: '/new-quality-settings/edit/:id',
    Title: 'Edit New Quality Settings',
    Component: EditNewQualitySettings,
    routes: []
  }



];

export default routes;
